import { RightOutlined, FrownOutlined } from '@ant-design/icons';
import { getCategoryByFrontCate } from '@/services';
import './index.scss';
import { Icon } from '@terminus/dqh-web-ui';
import { useNavigate } from 'react-router-dom';
import { useCurrentPage } from '@/hooks';

export function CategoryItem(props: any) {
  const {
    className,
    hasIcon,
    cutwords,
    isActive,
    category,
    showSub,
    level: currentLevel,
    parent,
  } = props;
  const {
    frontCateName: name,
    level,
    frontCateCode: code,
    frontCateLog,
    id,
  } = category;
  const navigate = useNavigate();
  const currentPage = useCurrentPage((state)=>state.currentPage);
  const pathname = currentPage === 'business-opportunity' ? '/go' : '/s';

  const contentText = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {hasIcon ? (
        <Icon
          name={frontCateLog || 'pingguoapple-one'}
          style={{ marginRight: 8 }}
        />
      ) : null}
      <span className="nav-category-name">{name}</span>
    </div>
  );

  let contentItem = null;

  const handleClick = async() => {
      const href =
        currentLevel === 'first'
          ? `${pathname}/search?level=1&category=${code}&categoryId=${id}`
          : `${pathname}/search?level=2&category=${code}&parentCode=${parent?.frontCateCode}&categoryId=${id}`;
        navigate(href);
    // if (currentPage === 'business-opportunity') {
    //   navigate(href);
    // } else {
    //   navigate(href);
    // }
  }
  
  contentItem = (
    <a onClick={()=>{
      handleClick()
      // navigate(href)
    }} rel="noopener noreferrer" style={{ cursor: 'pointer' }}>
      {contentText}
    </a>
  );

  return (
    <span
      className={`${className} ${cutwords ? 'sg-cutwords' : ''} ${
        isActive ? 'active' : ''
      }`}
      title={name}
      style={{ cursor: 'pointer' }}
    >
      {contentItem}
      {level === 1 && !showSub ? <RightOutlined /> : null}
    </span>
  );
}
